<template>
  <div v-bind:class="{'disable': disable}" class="notification">
    <div class="container">
      <button v-on:click="closeNotification" class="close-btn">X</button>
      
      <div v-if="sample" class="text-left sample-message">
        <p class="str-sample">{{message}}</p>
        <div v-if="progressive" ref="progress" class="progress"></div>
      </div>
      <div v-if="cotizador" class="cotizador">
        <div class="txt-left">
          <p class="str" >{{ $t('notification.calculate_title') }}</p>
          <div class="row form">
            <div class="col-md-12 col-lg-12 col-xl-6 not-padding">
              <div class="con-i" style="white-space:nowrap">
                <input @keypress="isNumber($event)" v-model="goles" type="text" maxlength="3" :placeholder="$t('notification.calculate_goles_limits')" value="" />
              </div>
              <div class="con-i" style="white-space:nowrap">
                <input @keypress="isNumber($event)" v-model="costo" type="text" :placeholder="$t('notification.calculate_cost_limits')" value="" />
              </div>
            </div>
            <div class="col-md-12 col-lg-12 col-xl-6 not-padding">
              <div class="con-i" style="white-space:nowrap">
                <input @keypress="isNumber($event)" v-model="edad" type="text" maxlength="2" :placeholder="$t('notification.calculate_age_limits')" value="" />
              </div>
              <div class="con-i" style="white-space:nowrap">
                <input @keypress="isNumber($event)" v-model="tiempo" type="text" maxlength="2" :placeholder="$t('notification.calculate_time_limits')" value=""/>
              </div>
            </div>

            <div class="col-md-12 col-lg-12 col-xl-12 not-padding">
              <div class="con-i col-xl-6 not-padding" style="padding: 0 15px 0 0;">
                <input @keypress="isNumber($event)" v-model="minutos" maxlength="3" :placeholder="$t('notification.calculate_minutes_limits')"  value=""/>
              </div>
              <div class="con-i" style="white-space:nowrap; margin-top: 15px;">
                <label class=" lab-sle value-select" for="id1">{{ $t('admin.select_postions_value') }}:</label>
                <div class="dropdown f-l">
                  <template class="btn-d">
                    <select v-if="$t('flag.flag') == 'es'" v-model="position" class="browser-default custom-select btn-d">
                      <option selected value="">-</option>
                      <option v-for="item in positionsEsp" :key="item.id" :value=item.value >{{item.position}}</option>
                    </select>
                    <select v-else v-model="position" class="browser-default custom-select btn-d">
                      <option selected value="">-</option>
                      <option v-for="item in positions" :key="item.id" :value=item.value >{{item.position}}</option>
                    </select>
                  </template>
                </div>
              </div>
            </div>

            <!--div class="col-md-12 col-lg-12 col-xl-6 not-padding">
              <div class="con-i" style="white-space:nowrap">
                <label class=" lab-sle value-select" for="id1">{{ $t('admin.select_postions_def') }}:</label>
                <div class="dropdown f-l">
                  <template class="btn-d">
                    <select v-if="$t('flag.flag') == 'es'" v-model="position" class="browser-default custom-select btn-d">
                      <option selected value="">-</option>
                      <option v-for="item in positionsDefEsp" :key="item.id" :value=item.value >{{item.position}}</option>
                    </select>
                    <select v-else v-model="position" class="browser-default custom-select btn-d">
                      <option selected value="">-</option>
                      <option v-for="item in positionsDef" :key="item.id" :value=item.value >{{item.position}}</option>
                    </select>
                  </template>
                </div>
              </div>
              <div class="con-i" style="white-space:nowrap">
                <label class=" lab-sle value-select" for="id1">{{ $t('admin.select_postions_ofe') }}:</label>
                <div class="dropdown f-l">
                  <template class="btn-d">
                    <select v-if="$t('flag.flag') == 'es'" v-model="position" class="browser-default custom-select btn-d">
                      <option selected value="">-</option>
                      <option v-for="item in positionsOfeEsp" :key="item.id" :value=item.value >{{item.position}}</option>
                    </select>
                    <select v-else v-model="position" class="browser-default custom-select btn-d">
                      <option selected value="">-</option>
                      <option v-for="item in positionsOfe" :key="item.id" :value=item.value >{{item.position}}</option>
                    </select>
                  </template>
                </div>
              </div>
            </div>-->
            
            <div class="col-md-12 not-padding">
              <p>{{ $t('notification.calculate_value') }}:
                <input type="hidden"  id="id1" :value="'$ ' + valuePlayerText + ''"/>
                <span v-if="valorFuturoA == '-' && valorFuturoB == '-'">$ xxx,xxx.xx'</span>
                <span v-else>${{valorFuturoA}} - ${{valorFuturoB}} </span>
              </p>
              <!--
              <small class="small">{{$t('notification.range') }}: +/- 1.5</small>
              -->
            </div>

            <div class="col-md-12 text-copy-right">
              <p>{{ $t('home.avise_cal') }}</p>
            </div>

          </div>
        </div>
      </div>
      <div v-if="listContent" class="container-all" v-bind:class="{'container-all-close': clean}">
        <div class="msg">
          <div v-if="gralList" class="gral_list">
            <span class="name-user">{{name}}</span>
            {{message}}
            <button v-on:click="openList" class="btn-al">{{ $t('notification.add_player_button') }}</button>
          </div>
          <div v-if="selectedList" class="gral_list">
            <span>{{$t('notification.select_list')}}</span>
            <button v-on:click="createListN" class="btn-al">{{$t('notification.select_list_button')}}</button>
          </div>
          <div v-if="createList" class="gral_list">
            <span>{{$t('notification.new_list_title')}}</span>
          </div>
        </div>
        <div v-bind:class="{'disableList': disableList}" class="otherList">
          <Lists :lists="parentList" :idPlayer="idPlayer" />
        </div>
        <div v-bind:class="{'createList': createList}" class="disableCreateList">
          <CreateList :userl="user" :idPlayer="idPlayer" />
        </div>
      </div>
      <div v-if="createListContainer" class="container-all" v-bind:class="{'container-all-close': clean}">
        <div class="gral_list_create">
          <span>{{$t('notification.new_list_title')}}</span>
        </div>
        <div v-bind:class="{'createList': createList}" class="disableCreateList">
          <CreateList :userl="user" :idPlayer="idPlayer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from "../parse/models/User";
import { bus } from "../main";
import Lists from "@/components/Lists";
import CreateList from "@/components/CreateList";

export default {
  name: "notification",
  props: {
    parentList: Array,
    user: Object,
  },
  components: {
    Lists,
    CreateList,
  },
  data() {
    return {
      clean: false,
      disable: this.$store.state.notification.disable,
      message: "",
      name: "",
      gralList: true,
      selectedList: false,
      createList: false,
      disableList: true,
      cotizador: false,
      sample: false,
      listContent: false,
      createListContainer: false,
      idPlayer: "",

      //Upload bar
      progressive: false,
      uploadBar: 0,

      //CALCULATE
      goles: "",
      edad: "",
      costo: "",
      tiempo: "",
      minutos: "",
      valorFuturoA: "-",
      valorFuturoB: "-",
      position: 0,
positionsEsp: [
        { position: "Jugador Defensivo (DFC, LI, LD, CRI, CRD, MD) ", value: 0 },
        { position: "Jugador Ofensivo (EXD, EXI, MO, DEL) ", value: 1 },
        /*{ position: "LB", value: 1 },
        { position: "RB", value: 1 },
        { position: "LWB", value: 1 },
        { position: "RWB", value: 1 },
        { position: "DM", value: 1 },
        { position: "LM", value: 1 },
        { position: "CM", value: 0 },
        { position: "RM", value: 1 },
        { position: "AM", value: 1 },
        { position: "S", value: 1 }*/
      ],
      positionsOfe: [
        { position: "LM", value: 1 },
        { position: "CM", value: 0 },
        { position: "RM", value: 1 },
        { position: "AM", value: 1 },
        { position: "S", value: 1 }
      ],
      positionsDefEsp: [
        { position: "DFC", value: 0 },
        { position: "LI", value: 1 },
        { position: "LD", value: 1 },
        { position: "CRI", value: 1 },
        { position: "CRD", value: 1 },
        { position: "MD", value: 1 },
      ],
      positions: [
        { position: "Defensive Player (CB, LB, RB, LWB, RWB, DM) ", value: 0 },
        { position: "Attacking Player (AM, LM, RM, S) ", value: 1 },

        /*{ position: "DFC", value: 0 },
        { position: "LI", value: 1 },
        { position: "LD", value: 1 },
        { position: "CRI", value: 1 },
        { position: "CRD", value: 1 },
        { position: "MD", value: 1 },
        { position: "EXD", value: 1 },
        { position: "MC", value: 0 },
        { position: "EXI", value: 1 },
        { position: "MO", value: 1 },
        { position: "DEL", value: 1 }*/
      ],
    };
  },
  beforeMounted() {
    console.log("Loading");
  },
  created() {

    bus.$on("disable", (value) => {
      this.message = ""
      //console.log("disable")
      this.disable = value.disable;
      this.name = value.name;
      this.message = value.message;
      this.idPlayer = value.id
      this.listContent = true

      localStorage.namePlayer = value.name;
    });
    
    bus.$on("cotizador", (value) => {
      
      this.message = ""
      this.disable = value.disable;
      this.cotizador = value.cotizador;
    });

    bus.$on("sample", (value) => {
      
      this.message = ""
      this.disable = value.disable;
      this.sample = value.sampleMessage;
      this.message = value.message;
      if(value.progressive){
        this.progressive = value.progressive
      }
      setTimeout(() => (this.closeNotification()), 5000);

    });

    bus.$on("sampleRedirect", (value) => {
      this.message = ""
      this.disable = value.disable;
      this.sample = value.sampleMessage;
      this.message = value.message;
      setTimeout(() => (this.redirect(value.redirect)), 5000);
    });

    bus.$on("sampleReload", (value) => {
      this.message = ""
      this.disable = value.disable;
      this.sample = value.sampleMessage;
      this.message = value.message;
      setTimeout(() => (this.sampleReload()), 5000);
    });

    bus.$on("upload", (value) => {
      this.message = ""
      this.disable = value.disable
      this.sample = value.sampleMessage
      this.message = value.message
      this.message = value.message
      this.progressive = value.progressive
    });

    bus.$on("progressiveBar", (value) => {
      this.uploadBar = value.percentage;
      this.frameBar(this.uploadBar)
    });

    bus.$on("close", (value) => {
      this.message = ""
      this.closeNotification()
    })

    bus.$on("closeUpload", (value) => {
      
      this.message = ""
      
      bus.$emit('save', value)
      this.closeNotification()
    })
    bus.$on("closeImg", (value) => {
      this.message = ""
      this.closeNotification()
    })
    bus.$on("createList", (value) => {
      this.message = ""
      this.disable = value.disable;
      this.sample = value.sampleMessage;
      this.createListContainer = true

      this.createListN()
    })

  },
  watch: {
    edad: function (val) {
      this.edad = val
    },
    goles: function (val) {
      this.goles = val
    },
    tiempo:  function (val) {
      this.tiempo = val
    },
    costo:  function (val) {
      this.costo = val
    },
    minutos:  function (val) {
      this.minutos = val
    },
    position: function(val){
      this.position = val
    }
  },
  computed:{
    // a computed getter
    valuePlayerText: function () {

      //Edad salida: ed
      //Valor actual: va
      //Goles cada 90: g
      //Tiempo en el equipo: t
      //Position: p

      const ed = this.edad
      const va = this.costo
      const g = this.goles
      const mj = this.minutos
      const t = this.tiempo
      const p = this.position
    
      const step0 = -93.06375 * 1

      const step1 = -9.21533 * ed
      
      const step2 = 0.9461015 * (ed ** 2)
      
      const step3 = -0.0167813 * (ed ** 3)

      const step4 = 0.51264 * va

      const step5 = -0.003190572 * (ed * va)

      const step6 = 0.01005511 * ((ed ** 2) * va)

      const step7 = -0.2136331 * (va ** 2)

      const step8 = 0.02435887 * (ed * (va ** 2))

      const step9 = -0.01660457 * (va ** 3)
      
      const step10 = -347.0811 * g

      const step11 = 15.7857 * (ed * g)

      const step12 = -0.2224389 * ((ed ** 2) * g) 

      const step13 = -5.463442 * (va * g)

      const step14 = -0.221211 * (ed * va * g )

      const step15 = 0.4946073 * ((va ** 2) * g)

      const step16 = -253.4757 * (g ** 2)

      const step17 = -3.288398 * (ed * (g ** 2))

      const step18 = -0.7072183 * (va * (g ** 2))

      const step19 = 51.00092 * (g ** 3)

      const step20 = 3.903226 * mj

      const step21 = -0.3334107 * (ed * mj)

      const step22 = 0.004741693 * ((ed ** 2) * mj)

      const step23 = -0.05258241 * (va * mj)

      const step24 = -0.009549707 * (ed * va * mj)

      const step25 = 0.003305072 * ((va ** 2) * mj)

      const step26 = 1.513651 * (g * mj) 

      const step27 = 0.04829708 * (ed * g * mj) 

      const step28 = 0.1893148 * (va * g * mj) 
      
      const step29 = 1.723887 * ((g ** 2) * mj) 

      const step30 = 0.02251543 * (mj ** 2)
      
      const step31 = 0.0004817819 * (ed * (mj ** 2))

      const step32 = 0.001858747 * (va * (mj ** 2)) 

      const step33 = -0.007977845 * (g * (mj ** 2)) 

      const step34 = -0.000214256 * (mj ** 3) 

      const step35 = 115.6528 * t

      const step36 = -5.092706 * (ed * t)

      const step37 = 0.0549628 * ((ed ** 2) * t)

      const step38 = 1.745637 * (va * t) 

      const step39 = 0.03024749 * (ed * va * t)

      const step40 = -0.2430494 * ((va ** 2) * t)

      const step41 = -2.384678 * (g * t)

      const step42 = -1.326251 * (ed * g * t) 

      const step43 = 3.083756 * (va * g * t)

      const step44 = 17.01296 * ((g ** 2) * t)

      const step45 = -0.6070962 * (mj * t)

      const step46 = 0.0005691136 * (ed * mj * t)

      const step47 = -0.01184727 * (va * mj * t)

      const step48 = -0.2409825 * (g * mj * t)

      const step49 = 0.004400855 * ((mj ** 2) * t)

      const step50 = -8.667472 * (t ** 2)    

      const step51 = 0.455782 * (ed * (t ** 2))

      const step52 = -0.02189407 * (va * (t ** 2))

      const step53 = 7.122027 * (g * (t ** 2))

      const step54 = -0.03999681 * (mj * (t ** 2))
      
      const step55 = -0.04875619 * (t ** 3)

      const step56 = 139.4702 * p

      const step57 = -6.723016 * (ed * p)

      const step58 = 0.03932158 * ((ed ** 2) * p)

      const step59 = 6.878217 * (va * p)
      
      const step60 = -0.02156677 * (ed * va * p)

      const step61 = -0.2284307 * ((va ** 2) * p)

      const step62 = 294.5083 * (g * p)
      
      const step63 = -2.653231 * (ed * g * p)
      
      const step64 = -13.96851 * (va * g * p)

      const step65 = 115.4244* ((g ** 2) * p)

      const step66 = -1.436124 * (mj * p)

      const step67 = 0.04597876 * (ed * mj * p)
      
      const step68 = -0.02646562 * (va * mj * p)
      
      const step69 = -2.548188 * (g * mj * p)
      
      const step70 = 0.001253137 * ((mj ** 2) * p)
      
      const step71 = -16.60522 * (t * p)
      
      const step72 = 0.5718988 * (ed * t * p)
      
      const step73 = -0.7264003 * (va * t * p)
      
      const step74 = 0.8484113 * (g * t * p)
      
      const step75 = 0.1739075 * (mj * t * p)
      
      const step76 = -2.198908 * ((t ** 2) * p) 

      const subtotal = Math.round((step0 + step1 + step2 + step3 + step4 + step5 + step6 + step7 + step8 + step9 + step10  + step11 + step12 + step13 + step14 + step15 + step16 + step17 + step18 + step19 + step20 + step21 + step22 + step23 + step24 + step25 + step26 + step27 + step28 + step29 + step30 + step31 + step32 + step33 + step34 + step35 + step36 + step37 + step38 + step39 + step40 + step41 + step42 + step43 + step44 + step45 + step46 + step47 + step48 + step49 + step50 + step51 + step52 + step53 + step54 + step55 + step56 + step57 + step58 + step59 + step60 + step61  + step62 + step63 + step64 + step65 + step66 + step67 + step68 + step69 + step70 + step71 + step72 + step73 + step74 + step75 + step76) * 100) / 100

      let result = subtotal


      const valorFA = (result - 0.5) * va
      const valorFB = (result + 0.5) * va
      
      this.info(valorFA, valorFB)

      if(parseInt(result) < 0){
        result = 'xxx,xxx.xx'
      }
        //value = result
      return result
      
    }
  },
  methods: {
    info(valorFA, valorFB){

      this.valorFuturoA = Math.round(valorFA * 100) / 100

      if(parseInt(this.valorFuturoA) < 0){
        this.valorFuturoA = 0
      }

      this.valorFuturoB = Math.round(valorFB * 100) / 100

      if(parseInt(this.valorFuturoB) < 0){
        this.valorFuturoB = 0
      }

    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if ( charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        //this.valuePlayer()
        return true;
      }
    },
    closeNotification() {

      this.listContent = false
      this.goles = ""
      this.edad = ""
      this.costo = ""
      this.tiempo = ""
      this.message = ""
      this.minutos = ""
      this.valorFuturoA = "-",
      this.valorFuturoB = "-",
      this.position = 0
      this.clean = true
      this.disable = true
      this.disableList = true
      this.createList = false
      this.gralList = true
      this.selectedList = false
      this.cotizador = false
      this.sample = false
      this.createListContainer = false

      //Progressive bar
      this.progressive = false
      
      bus.$emit("disable-list", undefined)
      setTimeout(() => (this.clean = false), 1000)
    },
    redirect(redirect) {
      this.goles = ""
      this.edad = ""
      this.costo = ""
      this.tiempo = ""
      this.valuePlayerText = "xxx,xxx.xx"
      this.clean = true
      this.disable = true
      this.disableList = true
      this.createList = false
      this.gralList = true
      this.selectedList = false
      this.cotizador = false
      this.sample = false
      this.createListContainer = false

      //Progressive bar
      this.progressive = false


      bus.$emit("disable-list", undefined)
      this.$router.push('/' + redirect)
    },
    openList() {
      this.gralList = false;
      this.selectedList = true;
      this.disableList = false;
    },
    createListN() {
      (this.createList = true), 200;
      this.gralList = false;
      this.selectedList = false;
      this.disableList = true;
    },
    /*valuePlayer(){
      
      const value = -7.4253 + this.goles * 4.5135 - (this.costo * 0.8962 ) + (this.edad * .4975 ) - (this.tiempo * 0.4944 )
      const valuea = this.costo * value
    
      this.valuePlayerText = this.formatPrice(valuea)
      if(parseInt(this.valuePlayerText) < 0){
        this.valuePlayerText = 0
      }
      
    },*/
    formatPrice(value) {
        const val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    frameBar(porcentage) {
      const $elem = this.$refs.progress;
      if (porcentage <= 100) {
        $elem.style.width = porcentage + "%";
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.progress{
  border-radius: 0;
  border: none;
  width: 0;
  height: 3px;
  background: #fff;
  margin-top: 10px ;
}


.gral_list_create{
  font-size: 11px;
  margin: 15px 0;
  text-align: left;
}

.text-copy-right p{
  text-align: left !important;
  font-size: 10px;
  color: #fff;
  padding-top: 5%;
}



/* --Sample message */

.sample-message{
  padding-top: 15px;
}

.str-sample{
  padding-top: 10px;
  font-family: "plain medium", arial;
  font-size: 11px;
}
/* --Cotizador */

.cotizador{
  padding-top: 15px;
}

.txt-left{
  text-align: left;
}

.str{
  font-family: "plain medium", arial;
  font-size: 11px;
}

.str-n{
  font-family: "plain medium", arial;
  font-size: 12px;
}

.form{
  padding: 0%;
  margin: 1% 0 0 0;
  height: 250px;
  display: flex;
}


.form input{
  font-family: 'plain medium', arial;
  width: 100px;
  border: 0;
  color: #fff;
  background: #000;
  border-bottom: 1px solid #fff;
  width: 100%;
  margin-top: 15px;
  padding: 10px 0;
}

.value-select{
  opacity: 0.5;
  font-weight: 600;
  margin-right: 10px;
  margin-top: 13px;
}

.custom-select {
  margin-top: 10px;
  background: #000 url("../assets/images/arrow_down_white.png") no-repeat right .75rem center/8px 10px;
  border: 1px solid #fff;
  border-radius: 0;
  color: #fff;
}


.custom-select:focus{
  border-color: #fff;
  box-shadow: none
}

.custom-select option {
  font-weight: 123px;
}



.form p{
  text-align: right;
  margin-top: 1%;
}

.small{
  float: right;
  font-size: 10px;
  margin-top: 5px;
}

.btn-action{
  border: 1px solid #fff;
  padding: 5px 15px;
  font-size: 12px;
  margin-top: 5px;
  color: #fff;
}

.btn-action img{
  width: 20px;
  margin-right: 5px;
}

.container-all {
  opacity: 1;
}

.container-all-close {
  opacity: 0;
}

.name-user {
  font-style: italic;
  margin-right: 5px;
}

.close-btn {
  width: 20px;
  height: 20px;
  border: 1px solid #fff;
  border-radius: 20px;
  background: #000;
  text-align: center;
  color: #fff;
  font-size: 12px;
  padding: 0;
  margin-top: 18px;
  float: right;
  margin-right: 16px;
}

.notification {
  background: #000;
  color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0px;
  height: auto;
  max-height: 1000px;
  overflow: hidden;
  transition: all 0.5s;
  padding-bottom: 100px;
  z-index: 10;
  border-radius: 0;
}

.disable {
  padding-bottom: 0;
  max-height: 0;
}

.msg {
  display: flex;
  align-items: center;
  margin-top: 23px;
  font-size: 12px;
}

.notification-a {
  padding: 50px;
}

.msg {
  text-align: left;
}

.btn-al {
  background: #000;
  color: #fff;
  border: none;
  text-decoration: underline;
  font-family: "plain regular", arial;
  padding: 4px;
}

.otherList {
  font-size: 12px;
  height: auto;
  max-height: 900px;
  overflow: hidden;
  text-align: left;
  transition: all 0.5s;
}

.disableList {
  max-height: 0;
}

.disableCreateList {
  max-height: 0;
  transition: all 0.5s;
  opacity: 0;
}

.createList {
  font-size: 12px;
  height: auto;
  max-height: 200px;
  overflow: hidden;
  text-align: left;
  transition: all 0.5s;
  opacity: 1;
}



@media (max-width: 992px) {

  .str{
    padding: 20px 15px;
  }
  .form {
    font-size: 12px;
  }

  .form input{
    margin-top: 0;
    padding: 10px 0;
  }
  .form p{
    margin-top: 10px;
  }
  .cotizador{
    padding: 0 0 40px;
  }
}
@media (max-width: 768px) {
  .cotizador{
    padding: 0 0 80px;
  }
}


</style>
